import { Link } from "react-router-dom";
import { FaWhatsapp, FaInstagram, FaTiktok, FaThreads } from "react-icons/fa6";
import { MapPin, Clock, ShieldCheck } from "lucide-react";
import { STORE, WA_DISPLAY, waLink, BRANDS } from "@/lib/constants";

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-white/10 bg-[#0B0C10]">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="mb-4 flex items-center gap-2.5">
            <img src="/assets/logo.png" alt="BigBerry Store" className="h-11 w-11 rounded-lg" />
            <div className="leading-none">
              <span className="block font-heading text-lg font-bold text-white">BigBerry</span>
              <span className="block text-[10px] uppercase tracking-[0.2em] text-berry">Store</span>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-gray-400">
            Reseller gadget premium bergaransi resmi & 100% brand new. Belanja aman, bisa cicilan,
            respons cepat via WhatsApp.
          </p>
          <div className="mt-4 flex items-center gap-2 text-sm text-electric">
            <ShieldCheck className="h-4 w-4" /> Garansi Resmi Indonesia
          </div>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Brand</h4>
          <ul className="grid grid-cols-2 gap-2 text-sm text-gray-400">
            {BRANDS.map((b) => (
              <li key={b}>
                <Link to={`/brand/${encodeURIComponent(b)}`} className="hover:text-white">
                  {b}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Informasi</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><Link to="/cara-pembelian" className="hover:text-white">Cara Beli & Cicilan</Link></li>
            <li><Link to="/tentang-kami" className="hover:text-white">Tentang Kami</Link></li>
            <li><Link to="/kontak" className="hover:text-white">Kontak</Link></li>
            <li><Link to="/kontak" className="hover:text-white">Kebijakan Garansi & Retur</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Hubungi Kami</h4>
          <ul className="space-y-3 text-sm text-gray-400">
            <li className="flex items-start gap-2">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-berry" />
              <span>{STORE.address}</span>
            </li>
            <li className="flex items-center gap-2">
              <Clock className="h-4 w-4 shrink-0 text-berry" />
              <span>{STORE.hours}</span>
            </li>
            <li>
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 rounded-full bg-whatsapp px-4 py-2 font-medium text-white transition-colors hover:bg-whatsapp-dark"
              >
                <FaWhatsapp className="h-4 w-4" /> {WA_DISPLAY}
              </a>
            </li>
          </ul>
          <div className="mt-5 flex items-center gap-3">
            <a href={STORE.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="rounded-full border border-white/10 p-2.5 text-gray-300 hover:border-berry hover:text-white">
              <FaInstagram className="h-4 w-4" />
            </a>
            <a href={STORE.social.threads} target="_blank" rel="noopener noreferrer" aria-label="Threads" className="rounded-full border border-white/10 p-2.5 text-gray-300 hover:border-berry hover:text-white">
              <FaThreads className="h-4 w-4" />
            </a>
            <a href={STORE.social.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="rounded-full border border-white/10 p-2.5 text-gray-300 hover:border-berry hover:text-white">
              <FaTiktok className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-5">
        <p className="text-center text-xs text-gray-500">
          © {new Date().getFullYear()} BigBerry Store · {STORE.domain} · Semua merek dagang milik pemiliknya masing-masing.
        </p>
      </div>
    </footer>
  );
}
